import * as React from 'react';
import { IReportDefinition, IReportOutput } from '@models/reports';
import { IMachinerySubType, ISecurity } from '@models';
import { search, searchExportToXls } from '@store/actions/search';
import {
    useDataTable, useLoading, useTranslation, useSearchFilters, Portal,
    classNames,
} from '@components';
import { downloadBlob } from '@utils/file-utils';
import './ReportOutputCrosstabComponent.scss';
import useSynchronizedDispatch from '@components/custom/useSynchronizedDispatch';

export interface IProps {
    filtersContext: any;
    filterParameters?: any;
    report: IReportDefinition;
    output: IReportOutput;
    security: ISecurity;
    workId: number;
}


export function ReportOutputCrosstabComponent(props: IProps) {
    const { t } = useTranslation();
    const [data, setData] = React.useState<any[]>([]);
    const [columns, setColumns] = React.useState<any[]>([]);
    const loading = useLoading();

    const report = props.report;
    const output = props.output;

    const calculateColumns = (result : any ) => {
        const tuple = result[0];
        let keys = Object.keys(tuple);
        const columns = keys.map((key: string) => {

        const propsColumn = props.output.columns?.find((c: any) => c.name == key);

            return {
                title: propsColumn?.title ?? key,
                className: classNames(propsColumn?.className ?? 'w200p center'),
                field: key,
                sortKey: key,
            }
        });
        setColumns(columns);
    }

    const initialize = loading.wrap(async (value: any) => {


        let filters = value
        if (filters.filters.machineryTypes == 0) {
            filters.filters.machineryTypes == null;
        }


        if (output.autoStart) {
            const res = await search(props.workId, output.searchName, {
                filters: value.filters ?? userFilters.filters,
            });

            if (res.value.length > 0) {
                calculateColumns(res.value);
                setData(res.value);
            }
            else {
                setData([]);
            }
        }
    });



    const dispatcher = useSynchronizedDispatch(initialize);

    const userFilters = useSearchFilters({
        security: props.security,
        workId: props.workId,
        name: output.searchName,
        references: props.filtersContext,
        persist: true,
        awaitForApply: true,
    });

    React.useEffect(() => {
        dispatcher.append({
            report: props.report,
            parameters: props.filterParameters,
            filters: userFilters.filters,
        });
    }, [props.report, props.filterParameters, userFilters.filters]);



    const dataTable = useDataTable({
        columns: columns,
        data: data,
        scrollHeight: '100%',
        scrollable: true,
        className: `ReportOutputCrosstabComponent ${props.report.className}`,
        tooltip: true,
        resizableColumns: true,
        lazy: true,
        paginator: true,
        rows: 100,
        rowsPerPageOptions: [100, 200, 300]
    });

    const exportToXls = async (filters: any, filename: string | undefined = undefined) => {
        const resp = await searchExportToXls(props.workId, output.searchName, {
            filters: filters,
        });
        downloadBlob(resp, filename ?? (report.title + '.xlsx'));
    }

    return <div className={'c he e'}>
        {loading.renderBox()}
        <Portal container='#breadcrumb-right'>
            <div className='r g-20' style={{ alignItems: 'center' }}>
                {output.canExport && <span className='exporter'>
                    <img
                        src='img/icons/excel-export-download.png'
                        className='pointer'
                        title={t('paginator.export')}
                        onClick={() => exportToXls(userFilters.filters)}
                        style={{ height: '23px', marginTop: '3px' }} />
                </span>}
                {userFilters.renderAsButton({ className: 'fas fa-filter pointer' })}
            </div>
        </Portal>
        {dataTable()}
    </div>
}
